"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _Raven = _interopRequireDefault(require("Raven"));

var _enviro = _interopRequireDefault(require("enviro"));

var _allSettled = _interopRequireDefault(require("q/js/lib/allSettled"));

var showDevOutput = !_enviro.default.deployed();
var WHITELIST = ['TimelineIntegrationEventStore.fetch'];

var makeBatch = function makeBatch(fetchById, apiName) {
  return function (ids) {
    var numIds = ids.size || ids.length;

    if (numIds > 2 && WHITELIST.indexOf(apiName) === -1) {
      var error = new Error("makeBatch(" + apiName + ") called with more than 2 IDs. This can cause performance issues waiting for the requests to resolve. Look into a batch endpoint.");

      if (showDevOutput) {
        // eslint-disable-next-line no-console
        console.error(error, ids.toJSON());
      } else {
        _Raven.default.captureException(error, {
          extra: {
            ids: ids.toJSON()
          }
        });
      }
    }

    var requests = ids.valueSeq().toArray().map(fetchById);
    return (0, _allSettled.default)(requests).then(function (result) {
      return result.reduce(function (acc, imp, index) {
        var id = ids.get(index);
        var value;

        if (imp.state === 'fulfilled') {
          value = imp.value;
        }

        return acc.set(id, value);
      }, (0, _immutable.Map)());
    });
  };
};

var _default = makeBatch;
exports.default = _default;
module.exports = exports.default;